export enum CmsElement {
    MOBILE_AD = 'E_Mobile_Ad',
    DISTURBER_CONTAINER = 'M_Resultlist_Disturber_Container',
    MAIL_AGENT_BANNER = 'E_MailAgent_Registration',
    RESULT_LIST_AD_1 = 'E_Resultlist_Disturber_Ad_1',
}

export enum CmsElementProperty {
    disturberPosition = 'meinestadt/types#resultlist_disturber_position',
    disturberIsLastPosition = 'meinestadt/types#resultlist_disturber_position_last',
    shareBarHeadline = 'meinestadt/types#exposee_share_headline',
    shareBarText = 'meinestadt/types#exposee_share_text',
    locationTypes = 'meinestadt/types#locationTypes',
    pageSizeDesktop = 'meinestadt/resultlist#realestatePageSizeDesktop',
    pageSizeMobile = 'meinestadt/resultlist#realestatePageSizeMobile',
    dfpPlacementIdMobile = 'meinestadt/advertising/types#dfpPlacementIdMobile',
    noResultsText = 'meinestadt/realEstate#noResultsText',
    iFrameUrl = 'meinestadt/realEstate#iFrameUrl',
    iFrameTrackingId = 'meinestadt/realEstate#iFrameTrackingIdentifier',
}
